import assets from 'marketing-website/configs/pages/enterprise/assets';

const invisionExperienceConfig = [
  {
    title: 'Pricing that scales as you do. No surprises.',
    subtitle:
      'Our customers love our predictable pricing and the confidence it gives them when planning how to scale design across their business. We build plans in partnership with you, complementing your unique organisational stucture and procurement needs.',
    image: assets.design,
  },
  {
    title: 'Around the clock support from your dedicated team',
    subtitle:
      'Every customer gets the personal support they need from our dedicated experience managers. That means you can pick up the phone or send an email to someone at Marvel that knows your needs inside and out.',
    image: assets.support,
  },
  {
    title: 'Our customers become our product partners',
    subtitle:
      'We work closely with our customers to build features and integrations that provide the most value in the workflow. Every decision we make ensures our core functionality is exactly what you need, rather than overwhelm your team with things you don’t.',
    image: assets.scalable,
  },
];

export default invisionExperienceConfig;



// WEBPACK FOOTER //
// ./src/components/modules/CompetitorAlternatives/invisionExperienceConfig.js